import React from "react";
import PropTypes from 'prop-types';

import FormControl from '@mui/material/FormControl';

import {
    MaterialSelect,
    StyledInputLabel,
    StyledMenuItem,
} from "./styled";
import { ThemedComponent } from "ui/theme";
import { InputAdornment } from "@mui/material";
import { Icon, InputRequired } from "ui/styled";

export const Select = ({
    placeholder,
    options,
    small,
    value,
    onChange,
    id,
    secondary,
    disabled,
    nolabel,
    icon,
    required,
    large
    ,multiple
}) => {

    const stop = (e) => {
        e.preventDefault?.();
        e.stopPropagation?.();
    };

    const optionAction = (e) => {
        stop(e);
        if (onChange && typeof onChange === 'function') {
            onChange(e.target.value);
        }
    };

    return (
        <>
            <ThemedComponent>
                <FormControl
                    variant="standard"
                    fullWidth
                    onMouseDown={stop}
                    onClick={stop}
                >
                    {nolabel ? null : (
                        <StyledInputLabel
                            id={id}
                            shrink
                        >
                            {placeholder} <InputRequired>{required ? "*" : ""}</InputRequired>
                        </StyledInputLabel>
                    )}

                    <MaterialSelect
                        MenuProps={{
                            PaperProps: {
                                elevation: 0,
                                sx: {
                                    mt: 1,
                                    borderRadius: '16px',
                                    border: theme => `1px solid ${theme.palette.colors.borderSoft}`,
                                    backgroundColor: theme => theme.palette.colors.surfaceElevated,
                                    boxShadow: theme => `0 18px 42px ${theme.palette.colors.shadowStrong}`,
                                    maxHeight: 'min(420px, calc(100vh - 96px))',
                                    overflowY: 'auto',
                                    scrollbarWidth: 'thin',
                                    scrollbarColor: theme => `${theme.palette.colors.subdued} ${theme.palette.colors.surfaceElevated}`,
                                    '&::-webkit-scrollbar': {
                                        width: 8,
                                    },
                                    '&::-webkit-scrollbar-track': {
                                        backgroundColor: theme => theme.palette.colors.surfaceElevated,
                                    },
                                    '&::-webkit-scrollbar-thumb': {
                                        backgroundColor: theme => theme.palette.colors.subdued,
                                        borderRadius: 8,
                                        border: theme => `2px solid ${theme.palette.colors.surfaceElevated}`,
                                    },
                                    '& .MuiMenuItem-root': {
                                        minHeight: large ? 44 : 40,
                                        fontSize: large ? 16 : 15,
                                    },
                                },
                            },
                            MenuListProps: {
                                sx: {
                                    py: 0.5,
                                },
                            },
                        }}
                        startAdornment={
                            icon ? (
                                <InputAdornment position="start" onMouseDown={stop} onClick={stop}>
                                    <Icon icon="word" />
                                </InputAdornment>
                            ) : null
                        }
                        small={small}
                        secondary={secondary}
                        labelId={id}
                        color={secondary ? 'secondary' : 'primary'}
                        id={`select-${id}`}
                        value={multiple ? (Array.isArray(value) ? value : value ? String(value).split(',').filter(Boolean) : []) : value}
                        multiple={multiple}
                        renderValue={selected => multiple
                            ? (options || []).filter(item => (Array.isArray(selected) ? selected : [selected]).map(String).includes(String(item.id))).map(item => item.title).join(', ')
                            : (options || []).find(item => String(item.id) === String(value))?.title || ''}
                        disableUnderline
                        onChange={optionAction}
                        label={placeholder}
                        disabled={disabled}
                        onMouseDown={stop}
                        onClick={stop}
                    >
                        {!options || options.length === 0 ? (
                            <StyledMenuItem disabled value="" onMouseDown={stop} onClick={stop}>
                                Nenhuma opção disponível
                            </StyledMenuItem>
                        ) : (
                            options.map((item, key) => (
                                <StyledMenuItem
                                    key={key}
                                    value={`${item.id}`}
                                    onMouseDown={stop}
                                    onClick={stop}
                                >
                                    {item?.title}
                                </StyledMenuItem>
                            ))
                        )}
                    </MaterialSelect>
                </FormControl>
            </ThemedComponent>
        </>
    );
};

Select.propTypes = {
    placeholder: PropTypes.string,
    options: PropTypes.array,
    value: PropTypes.any, // pq você passa string/id, não objeto
    small: PropTypes.bool,
    secondary: PropTypes.bool,
    large: PropTypes.bool,
    onChange: PropTypes.func.isRequired,
};

Select.defaultProps = {
    placeholder: '',
    options: [],
    value: '',
    small: false,
    secondary: false,
    large: false,
    onChange: undefined,
};

export default Select;
